import { useCreateRecruitmentContext } from '../../Create/Contexts/CreateRecruitmentContext';
import StepProps from '../StepProps';
import { buildDefaultValuesFromContext, type SelectTestsFormValues } from './SelectTestsStep.schema';
import SelectTestsStepForm from './SelectTestsStepForm';
import { useSelectTestsStepForm } from './useSelectTestsStepForm';
import { useNotificationContext } from '@/Context/NotificationContext';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

const SelectTestsStep = ({ activeStep, handleNext, handleBack }: StepProps) => {
    const { includedTests, setIncludedTests, testLanguage, setTestLanguage, processingState } =
        useCreateRecruitmentContext();

    const { showFailToaster } = useNotificationContext();

    const form = useSelectTestsStepForm(buildDefaultValuesFromContext(includedTests, testLanguage));

    const submitHandler = async (values: SelectTestsFormValues) => {
        const tests: TestTypes[] = [];

        if (values.isAptitudeSelected) {
            tests.push(TestTypes.Aptitude);
        }
        if (values.isEmotionalIntelligenceSelected) {
            tests.push(TestTypes.EmotionalIntelligence);
        }
        if (values.isPersonalitySelected) {
            tests.push(TestTypes.Personality);
        }
        if (values.isSkillsSelected) {
            tests.push(TestTypes.Skills);
        }

        setIncludedTests(tests);
        setTestLanguage(values.testLanguageField);

        if (handleNext) {
            handleNext();
        }
    };

    return (
        <SelectTestsStepForm
            form={form}
            processingState={processingState}
            activeStep={activeStep}
            handleBack={handleBack}
            onSubmit={submitHandler}
            onInvalid={() => showFailToaster(UIStrings.PleaseSelectAtLeastOneTestToContinue)}
            onBackPersistTestLanguage={setTestLanguage}
        />
    );
};

export default SelectTestsStep;
